import {
  IProjectColors,
  IProjectSpaceTypeCategory,
  IProjectSpaceTypeSubcategory,
} from 'spw-redux/modules/projects/types';
import { useMemo } from 'react';
import { getSubcategoryData } from '../utils';

export const useCategoryData = (
  projectSpaceTypeCategory: IProjectSpaceTypeCategory,
  projectColors: IProjectColors
) => {
  const { colors, titles } = useMemo(() => {
    return projectSpaceTypeCategory.subcategories?.reduce(
      (accumulator, subcategory: IProjectSpaceTypeSubcategory) => {
        const { color, title: subcategoryTitle } = getSubcategoryData(
          subcategory,
          projectColors
        );

        return {
          ...accumulator,
          titles: [...accumulator.titles, subcategoryTitle],
          colors: [...accumulator.colors, color],
        };
      },
      { colors: [], titles: [] }
    );
  }, [projectSpaceTypeCategory.subcategories, projectColors]);

  const getData = (
    subcategoriesData: {
      quantity: number;
      percent: number;
      name: string;
      color: string;
    }[]
  ) => {
    const data: (string | number)[][] = subcategoriesData.map(
      (subcategoryData) => {
        return [subcategoryData.name, subcategoryData.percent];
      }
    );

    data.unshift(['Space Type', 'Count']);

    return data;
  };

  return {
    colors,
    titles,
    getData,
  };
};
